import ReactMarkdown from 'react-markdown';

const DOCUMENT_MARKDOWN_COMPONENTS = {
  p: ({ children }) => <p className="mb-4 last:mb-0 leading-relaxed text-zinc-300">{children}</p>,
  ul: ({ children }) => <ul className="mb-4 last:mb-0 list-disc space-y-1 pl-4">{children}</ul>,
  ol: ({ children }) => <ol className="mb-4 last:mb-0 list-decimal space-y-1 pl-4">{children}</ol>,
  li: ({ children }) => <li className="leading-relaxed text-zinc-300">{children}</li>,
  h1: ({ children }) => <h1 className="mb-3 mt-6 text-xl font-semibold text-white first:mt-0">{children}</h1>,
  h2: ({ children }) => <h2 className="mb-3 mt-5 text-lg font-semibold text-white first:mt-0">{children}</h2>,
  h3: ({ children }) => <h3 className="mb-2 mt-4 text-base font-semibold text-white first:mt-0">{children}</h3>,
  strong: ({ children }) => <strong className="font-semibold text-white">{children}</strong>,
  code: ({ children }) => (
    <code className="rounded bg-zinc-800 px-1.5 py-0.5 font-mono text-sm text-zinc-200">{children}</code>
  ),
};

export const DocumentMarkdownContent = ({ content }) => (
  <div className="rounded-sm border border-zinc-800 bg-zinc-900/30 p-8">
    <div className="prose prose-invert prose-sm max-w-none">
      <ReactMarkdown components={DOCUMENT_MARKDOWN_COMPONENTS}>{content}</ReactMarkdown>
    </div>
  </div>
);
